import axios from "axios";

var baseURL = "https://loc.clearment.ai";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.clearment.ai"
) {
  baseURL = "https://loc.clearment.ai";
}

if (window.location.hostname == "www.clearment.ai") {
  baseURL = "https://www.clearment.ai";
}

const http = axios.create({
  baseURL: baseURL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export default http;
